module.exports = __webpack_public_path__ + "static/media/Union.45bb68bb.svg";